
export const text = `

Next time on ZampanioSim:

the basic definition of the trope is "soulful brooding male hero meets wacky quirky female sidekick that teaches him to embrace life"
we have:
 "soulful brooding male hero meets equally brooding female villain that teaches him i mean. nothing concrete he's just kind of scared the whole time"
  and
 "brooding but also literally a cop with no restraints male hero meets ikea schedule manager that teaches him to chill the fuck out while she tries to figure out if he actually is the previous soulful brooding male hero"

~~~~~~~~~~~~~
a: see i love this connection weve found between two chars who never have yet shared a scene together 

b: i mean it only makes sense
b: they're both beaten junkyard dogs
b: its just one of them is being trained by one of those dog agencies into a dog a family can adopt and the other one ran into the forest and eats peoples cats

 `